{
	"passwordUpdated": "Contraseña actualizada con éxito"
}
